import { useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition = ({ children }: PageTransitionProps) => {
  const location = useLocation();
  const [displayChildren, setDisplayChildren] = useState(children);
  const [transitionState, setTransitionState] = useState<"enter" | "exit">("enter");
  const prevKey = useRef(location.key);
  const isDiscussionSession = location.pathname.startsWith("/home/session/") && !location.pathname.endsWith("/report");

  useEffect(() => {
    if (location.key !== prevKey.current) {
      // Route changed — exit then enter
      setTransitionState("exit");
      const timeout = setTimeout(() => {
        setDisplayChildren(children);
        setTransitionState("enter");
        prevKey.current = location.key;
      }, 150);
      return () => clearTimeout(timeout);
    } else {
      setDisplayChildren(children);
    }
  }, [children, location.key]);

  return (
    <div
      className={`transition-all duration-200 ease-out ${isDiscussionSession ? "min-h-full lg:h-full lg:min-h-0 lg:overflow-hidden" : ""} ${
        transitionState === "enter"
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-1"
      }`}
    >
      {displayChildren}
    </div>
  );
};

export default PageTransition;
